class DocumentationPathUtils {

    setIndexContentHeight() {

        function _setHeight() {

            const $pathIndex = $("div.path-index");
            const $indexHeader = $("div.path-index > .header");
            const $indexTabs = $("div.path-index > .bf-tabs");
            const $indexContent = $("div.path-index .tab-content");
            const $tabs = $("div.path-index .nav-tabs");

            if ($indexContent.length > 0) {
                $indexTabs.removeClass("not-have-navigation-tabs");
                $indexContent.css("max-height", $window.height() - $indexHeader.outerHeight() - $tabs.outerHeight());
            } else {
                $indexTabs.addClass("not-have-navigation-tabs");
                $indexTabs.css("max-height", $window.height() - $indexHeader.outerHeight());
            }

            if ($pathIndex.length === 0) {
                $window.off("resize.pathIndexHeight");
            }

        }

        const $window = $(window);

        _setHeight();
        $window.off("resize.pathIndexHeight").on("resize.pathIndexHeight", _setHeight);

    }

    setPathMonoDocumentData(monoModeClassDocument) {

        const $documentDetailsBanner = $("div.document-details-banner");
        const $pastilIcon = $("div.document-details-banner img.document-type-icon");
        const $pastilTime = $("div.document-details-banner span.completion-time-text");
        const $documentTitle = $("#document-details-content p.document-title");
        const $documentDescription = $("#document-details-content div.documentDescription");

        const bannerImage = monoModeClassDocument.icon ? monoModeClassDocument.icon : '/images/uploadDocDefThumb.jpg';

        $documentDetailsBanner.css("background-image", "url(" + bannerImage + ")");
        $pastilIcon.attr("src", monoModeClassDocument.icon_type);
        $documentTitle.text(monoModeClassDocument.name);

        if (world.shows_completion) {

            if (monoModeClassDocument.completed_time_formatted) {
                $pastilTime.text(monoModeClassDocument.completed_time_formatted);
            } else if (monoModeClassDocument.media_duration_formatted) {
                $pastilTime.text(monoModeClassDocument.media_duration_formatted);
            }

        }

        if (monoModeClassDocument.html_description) {
            $documentDescription.text(monoModeClassDocument.html_description);
        } else {
            $documentDescription.remove();
        }

    }

    setPathWizardItemPreviewStyles() {

        const $window = $(window);
        const $wrapper = $("#documentationDetailSection > .wrapper");
        const $previewItem = $("div.path-wizard-preview-item");
        const $coverImage = $("div.path-wizard-preview-item > div.cover-image");
        const $previewItemShape = $("div.preview-item-shape");
        const $bottomOptionsBar = $("div.bottomOptionsBar.documentation-details");
        const $previewItemInfo = $("div.preview-item-info");
        const coverImageHeight = $previewItem.height() * 0.45;
        const shapeRoundedAngle = -22;

        $previewItemInfo.width($previewItem.width());

        $coverImage.css("height", coverImageHeight + "px");
        $previewItemShape.css("top", $coverImage.height() + shapeRoundedAngle + "px");

    }

    setPathWizardItemPreviewEllipsis() {

        const $previewItemTitle = $("div.preview-item-info > p.content-title");
        const $previewItemDescription = $("div.preview-item-info > p.content-description");

        const previewItemTitleDotOptions = {wrap: 'word', watch: true, height: 80, callback: this.setPathWizardItemPreviewStyles};
        const previewItemDescriptionDotOptions = {wrap: 'word', watch: true, height: 66, callback: this.setPathWizardItemPreviewStyles};

        $previewItemTitle.dotdotdot(previewItemTitleDotOptions);
        $previewItemDescription.dotdotdot(previewItemDescriptionDotOptions);

    }

    setPathEllipsis() {

        const $pathTitle = $("p.path-title");
        const $pathDescription = $("p.path-description");
        const $pathIndexTitle = $("div.path-index > div.header > p.title");

        const pathTitleDotOptions = {wrap: 'word', watch: true, height: 76};
        const pathDescriptionDotOptions = {wrap: 'word', watch: true, height: 88};
        const pathIndexTitleDotOptions = {wrap: 'word', watch: true, height: 83};

        $pathTitle.dotdotdot(pathTitleDotOptions);
        $pathDescription.dotdotdot(pathDescriptionDotOptions);
        $pathIndexTitle.dotdotdot(pathIndexTitleDotOptions);

    }

    setKeepTheLoopEllipsis() {

        const $keepTheLoopSectionName = $("div.keep-the-loop p.section");
        const $keepTheLoopDocName = $("div.keep-the-loop p.name");

        const keepTheLoopSectionDotOptions = {wrap: 'word', watch: true, height: 20};
        const keepTheLoopDocNameDotOptions = {wrap: 'word', watch: true, height: 36};

        $keepTheLoopSectionName.dotdotdot(keepTheLoopSectionDotOptions);
        $keepTheLoopDocName.dotdotdot(keepTheLoopDocNameDotOptions);

    }

    markSectionDocumentAsCompleted(path, documentId) {

        // Se incrementa el numero de documentos completados
        path.completedDocuments += 1;

        // Se marca el documento de la seccion como completado
        const sections = path.sections;

        _.forEach(sections, function(section){
            _.forEach(section.items, function(item) {

                if (item.id === documentId) {
                    item.completed = true;
                }

            })

        });

        return path;

    }

    getAssessmentLevel(document, assessmentLevels) {

        const assessmentResults = document.own_game ? document.own_game.games[0] : document.own_test.games[0];
        const numQuestions = document.own_game ? document.own_game.num_questions : document.own_test.num_questions;
        const answeredCorrectly = assessmentResults.answered_correctly
        let successRateQuestions = (answeredCorrectly / parseInt(numQuestions)) * 100;

        if (successRateQuestions < 30) {
            return assessmentLevels.LOW;
        }

        if (successRateQuestions >= 30 && successRateQuestions < 60) {
            return assessmentLevels.MEDIUM;
        }

        if (successRateQuestions >= 60) {
            return assessmentLevels.HIGH;
        }

    }

    getBlockedByRequirement(blockers, selectedBlockers) {

        return _.some(selectedBlockers, function(selectedBlocker) {

            const blockedByContent = selectedBlocker.type === blockers.BLOCKER_SEQUENTIAL_BY_CONTENT;
            const blockedBySection = selectedBlocker.type === blockers.BLOCKER_SEQUENTIAL_BY_SECTION;

            return blockedByContent || blockedBySection;

        });

    }

    getBlockedByDate(blockers, selectedBlockers) {

        return _.some(selectedBlockers, function(selectedBlocker) {

            const blockedByDate = selectedBlocker.type === blockers.BLOCKER_PLANNER_DATE;
            return blockedByDate;

        });

    }

    getFirstClass(path) {
        return path.sections[0].items[0];
    }

    getPathWizardItemPosition(path, documentId) {
        return _.findIndex(path.sections[0].items, {id: documentId});
    }

    tintPathIcons() {

        const $outstandingMaterialIcon = $("#material-icon-type");
        tintImage($outstandingMaterialIcon.attr("id"), $outstandingMaterialIcon.data("icon"), world.theme.color_1);

    }

    formatSections(path) {

        const documentationProgress = documentationScreenController.documentationProgress;
        const pathModes = documentationScreenController.documentationPath.getPathModes();

        _.forEach(path.sections, function(section) {

            const sectionItems = [];
            let completedSectionItems = 0;

            _.forEach(section.items, function(item) {

                DocumentationUtils.formatDocumentParameters(item.document);

                item.document.pathItemId = item.id;
                item.document.isBlocked = item.is_blocked;
                item.document.order = item.order;
                item.document.outstanding = item.outstanding;
                item.document.progressState = documentationProgress.getProgressState(item.document);
                item.document.enabledLinks = item.document.enabled_links;
                item.document.type = item.document.api_name_type;

                if (item.document.completed) {
                    completedSectionItems += 1;
                }

                sectionItems.push(item.document);

            });

            section.items = sectionItems;
            section.percentage = (completedSectionItems / section.items.length) * 100;

            if (section.percentage === 100) {
                section.progress = documentationProgress.COMPLETED;
            } else if (section.percentage > 0 && section.percentage < 100) {
                section.progress = documentationProgress.IN_PROCESS;
            } else {
                section.progress = documentationProgress.NOT_STARTED;
            }


        });

        return path.sections;

    }

    formatMaterials(path) {

        const documentationProgress = documentationScreenController.documentationProgress;
        const materialsItems = [];

        if (path.materials) {

            _.forEach(path.materials.items, function (item) {

                item.document.pathItemId = item.id;
                item.document.isBlocked = item.is_blocked;
                item.document.order = item.order;
                item.document.outstanding = item.outstanding;
                item.document.progressState = documentationProgress.getProgressState(item.document);

                materialsItems.push(item.document);

            });

            path.materials.items = materialsItems;

        }

        return path.materials;

    }

    formatTest(path) {
        if (path.test.document && path.test.enabled) {

            const documentationProgress = documentationScreenController.documentationProgress;
            const numberOfDocuments = this.getNumberOfClasses(path);
            const completedDocuments = this.getCompletedDocuments(path);

            path.test.document.special_view = true;
            path.test.document.isBlocked = numberOfDocuments !== completedDocuments;
            path.test.document.own_test.best_game = _.maxBy(path.test.document.own_test.games, function(game) { return game.qualification });
            path.test.document.own_test.last_game = _.maxBy(path.test.document.own_test.games, function(game) { return game.end_date });
            path.test.document.new = false;

            if (path.test.document.own_test.best_game) {
                const ownTest = path.test.document.own_test;
                const bestGame = ownTest.best_game;

                path.test.document.completed = bestGame.qualification >= ownTest.minimum_qualification || parseInt(ownTest.tries) === ownTest.maximum_tries;

                if (path.test.document.completed) {
                    path.test.document.own_test.tries = ownTest.maximum_tries;
                }

            }
        }

        return path.test.document ?? {};
    }

    sortSections(sections) {

        let sortedSections = [];
        let sortedSectionsItems = [];

        sortedSections = _.sortBy(sections, function (section) {

            sortedSectionsItems = _.sortBy(section.items, function(item) {
                return item.order;
            });

            section.items = sortedSectionsItems;
            return section.order;

        });

        return sortedSections;

    }

    sortMaterials(materials) {

        let sortedMaterials = []

        if (materials) {

            sortedMaterials = _.sortBy(materials.items, function(item) {
                return item.order;
            });

        }

        return sortedMaterials;

    }

    getCompletedDocuments(path) {

        return _.sumBy(path.sections, function(section) {
            return _.filter(section.items, "completed").length;
        });

    }

    getIsCourseInOrder(path) {

        // Para backend la cover 8 se corresponde con la vista CARD_ART con el curso en orden (progreso a la izquierda de las CARD_ART)
        // Para frontend la cover 8 no es una nueva cover sino una propiedad de las vistas
        return path.cover === 8;

    }

    getNumberOfClasses(path) {

        return _.sumBy(path.sections, "items.length");

    }

    getIsDashboardEnabled(path, progressState, pathMode) {

        const documentationProgress = documentationScreenController.documentationProgress;
        const documentationPath = documentationScreenController.documentationPath;
        const pathModes = documentationPath.getPathModes();

        if (pathMode === pathModes.NORMAL_MODE || pathMode === pathModes.WALL_MODE) {

            if (path.assessment) {
                return path.assessment.enabled === false || (path.assessment.enabled && path.assessment.did_it);
            }

            return true;

        }

        if (pathMode === pathModes.WIZARD_MODE) {
            return progressState.state === documentationProgress.COMPLETED;
        }

        if (pathMode === pathModes.MONO_MODE) {
            return true;
        }

    }

    getOutstandingMaterial(path) {

        let outstandingMaterial = null;

        if (path.materials) {

            _.forEach(path.materials.items, function(material) {

                if (material.outstanding) {

                    outstandingMaterial = {
                        id: material.pathItemId,
                        title: material.name,
                        iconType: material.icon_type
                    }

                }

            });

        }

        return outstandingMaterial;

    }

    getNextClassToComplete(path) {
        const documentationProgress = documentationScreenController.documentationProgress;
        let documentInProgress = null;
        let documentNotStarted = null;

        _.forEach(path.sections, function (section) {
            _.forEach(section.items, function (item) {

                //progressState : "NOT_STARTED"
                if (!documentNotStarted && item.progressState === documentationProgress.NOT_STARTED) {
                    documentNotStarted = item;
                }

                //progressState : "IN_PROCESS"
                if (!documentInProgress && item.progressState === documentationProgress.IN_PROCESS) {
                    documentInProgress = item;
                    return false;
                }

            });

            if (documentInProgress) {
                return false;
            }

        });

        return documentInProgress ? documentInProgress : documentNotStarted;
    }

    getSectionItemsDict(path) {

        const sectionItemsDict = {};

        _.forEach(path.sections, function(section) {
                _.forEach(section.items, function(item) {
                    sectionItemsDict[item.pathItemId] = section;
                });
        });

        return sectionItemsDict;

    }

    getIsCourseStarted(path) {

        return _.some(path.sections, function(section) {
            return _.some(section.items, "read");
        });

    }

    getPathMode(pathData) {

        return pathData.mode;

    }

    getMonoModeClassDocument(pathData, pathMode) {

        const pathModes = documentationScreenController.documentationPath.getPathModes();

        if (pathMode === pathModes.MONO_MODE) {

            const documentId = pathData.sections[0].items[0].id;
            const document = documentationScreenController.getDocument(documentId);

            if (!document.question_category) {
                document.question_category = {
                    title: Translator.trans("TR_GENERAL")
                }
            }

            DocumentationUtils.formatDocumentParameters(document)

            return document;

        }

    }

    getSectionItem(documentId) {

        const pathData = documentationScreenController.documentationPath.getPathData();
        let document = null;

        _.forEach(pathData.sections, function(section) {

            document = _.find(section.items, function(item) {
                return item.id === documentId;
            });

            if (document) {
                return false;
            }

        });

        return document;

    }

    parseJsonResponse(path) {

        const documentationProgress = documentationScreenController.documentationProgress;

        const formattedSections = this.formatSections(path);
        const formattedMaterials = this.formatMaterials(path);
        const formattedTest = this.formatTest(path);
        const sortedSections = this.sortSections(formattedSections);
        const sortedMaterials = this.sortMaterials(formattedMaterials);

        const pathMode = this.getPathMode(path);
        const monoModeClassDocument = this.getMonoModeClassDocument(path, pathMode);
        const coverName = smartListsController.getSmartListName(path.cover);
        const etaFormatted = DocumentationUtils.formatCompletedTime(path.eta * 1000);
        const courseInOrder = this.getIsCourseInOrder(path);
        const numberOfContents = this.getNumberOfClasses(path);
        const completedDocuments = this.getCompletedDocuments(path);
        const outstandingMaterial = this.getOutstandingMaterial(path);
        const nextDocumentToComplete = this.getNextClassToComplete(path);
        const sectionItemsDict = this.getSectionItemsDict(path);
        const courseStarted = this.getIsCourseStarted(path);
        const progressState = documentationProgress.getPathProgress(path, numberOfContents, completedDocuments, monoModeClassDocument);
        const dashboardEnabled = this.getIsDashboardEnabled(path, progressState, pathMode);

        path.sections = sortedSections;

        if (path.materials) {
            path.materials.items = sortedMaterials;
        }

        path.test.document = formattedTest;

        path.mode = pathMode;
        path.monoModeClassDocument = monoModeClassDocument;
        path.coverName = coverName;
        path.etaFormatted = etaFormatted;
        path.courseInOrder = courseInOrder;
        path.numberOfContents = numberOfContents;
        path.completedDocuments = completedDocuments;
        path.dashboardEnabled = dashboardEnabled;
        path.outstandingMaterial = outstandingMaterial;
        path.nextDocumentToComplete = nextDocumentToComplete;
        path.sectionItemsDict = sectionItemsDict;
        path.courseStarted = courseStarted;
        path.progressState = progressState;

        return path;


    }

}